<template>
  <div v-if="socialMediaAccounts">
    <h3 class="mb-4 font-medium leading-snug uppercase fluid-xs">{{ $t('navigation.followUs') }}</h3>
    <InlineIconsGrid class="-ml-2 -mr-2">
      <div v-for="(account, idx) in socialMediaAccounts.socialMediaAccounts" :key="idx">
        <a
          :href="account.accountUrl"
          target="_blank"
          class="flex p-2 transition-all hover:opacity-60 w-9"
          :title="$t('socialmedia.' + account.network)"
        >
          <FacebookIcon v-if="account.network === 'facebook'" class="h-5" />
          <InstagramIcon v-if="account.network === 'instagram'" class="h-5" />
          <YoutubeIcon v-if="account.network === 'youtube'" class="h-5" />
          <LinkedinIcon v-if="account.network === 'linkedin'" class="h-5" />
        </a>
      </div>
    </InlineIconsGrid>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import FacebookIcon from '@/components/icons/FacebookIcon';
import InstagramIcon from '@/components/icons/InstagramIcon';
import YoutubeIcon from '@/components/icons/YoutubeIcon';
import InlineIconsGrid from '@/components/common/InlineIconsGrid';
import LinkedinIcon from '@/components/icons/LinkedinIcon';

export const SocialMediaAccountsFragment = gql`
  fragment SocialMediaAccountsFragment on socialMediaAccounts_GlobalSet {
    socialMediaAccounts {
      ... on socialMediaAccountsBlock_Entry {
        network
        accountUrl
      }
    }
  }
`;

export default defineNuxtComponent({
  components: { LinkedinIcon, InlineIconsGrid, YoutubeIcon, InstagramIcon, FacebookIcon },
  props: {
    socialMediaAccounts: {
      type: Object,
      default: () => ({}),
    },
  },
});
</script>
